import React, { useEffect, useRef, useState } from 'react';

const LuxuryCursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const labelRef = useRef(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const finePointer = window.matchMedia('(pointer: fine)').matches;
    if (!finePointer) return undefined;
    setEnabled(true);

    let mouseX = -100;
    let mouseY = -100;
    let ringX = -100;
    let ringY = -100;
    let frame;

    const move = (event) => {
      mouseX = event.clientX;
      mouseY = event.clientY;
      if (dotRef.current) dotRef.current.style.transform = `translate3d(${mouseX}px, ${mouseY}px, 0)`;
      if (labelRef.current) labelRef.current.style.transform = `translate3d(${mouseX}px, ${mouseY}px, 0)`;
    };

    const tick = () => {
      ringX += (mouseX - ringX) * 0.14;
      ringY += (mouseY - ringY) * 0.14;
      if (ringRef.current) ringRef.current.style.transform = `translate3d(${ringX}px, ${ringY}px, 0)`;
      frame = requestAnimationFrame(tick);
    };

    const overInteractive = (event) => {
      const target = event.target.closest('a, button, [role="button"], .image-hover, .group');
      const label = target?.dataset?.cursorLabel || (target?.matches('.image-hover, .group') ? 'VIEW' : '');
      document.body.classList.toggle('cursor-hovering', Boolean(target));
      document.body.classList.toggle('cursor-viewing', Boolean(label));
      if (labelRef.current) labelRef.current.textContent = label;
    };

    window.addEventListener('mousemove', move, { passive: true });
    window.addEventListener('mouseover', overInteractive, { passive: true });
    frame = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseover', overInteractive);
      cancelAnimationFrame(frame);
      document.body.classList.remove('cursor-hovering', 'cursor-viewing');
    };
  }, []);

  if (!enabled) return null;

  return (
    <>
      <span ref={dotRef} className="luxury-cursor-dot" aria-hidden="true" />
      <span ref={ringRef} className="luxury-cursor-ring" aria-hidden="true" />
      <span ref={labelRef} className="luxury-cursor-label" aria-hidden="true" />
    </>
  );
};

export default LuxuryCursor;
